<template>
  <!-- The Follow up page (Mohammed 04/10/2026): one page, two tabs. Each tab is its own route
       (/followUp/goingOut, /followUp/sent), so a tab can be bookmarked and Back works. -->
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card followup-page">
        <h4>Follow up</h4>
        <TabMenu id="followUpTabs" :model="tabs" />
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export const FOLLOW_UP_TABS = [
  { label: 'Emails Going Out', icon: 'pi pi-fw pi-envelope', to: '/followUp/goingOut' },
  { label: 'Emails Sent', icon: 'pi pi-fw pi-inbox', to: '/followUp/sent' }
]

export default {
  name: 'FollowUp',
  data: () => ({ tabs: FOLLOW_UP_TABS })
}
</script>

<style scoped>
.followup-page h4 {
  margin-bottom: 0.75rem;
}
</style>
